import {
  Car, Truck, Crane, Clock, RoadHorizon, ShieldCheck, Medal, Lightning,
  UsersThree, Gear, MapTrifold, Tag,
} from "@phosphor-icons/react";

const MAP = {
  Car, Truck, Crane, Clock, Road: RoadHorizon, ShieldCheck, Medal, Lightning,
  UsersThree, Gear, MapTrifold, Tag,
};

export default function Icon({ name, ...props }) {
  const Cmp = MAP[name] || ShieldCheck;
  return <Cmp {...props} />;
}
